<script setup lang="ts">
import { EToast, ETooltipProvider, provideUiStrings } from '@erpx/ui'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import AppShell from '@/components/AppShell.vue'
import StepUpDialog from '@/components/StepUpDialog.vue'
import { uiStringsBundle } from '@/i18n/uiStrings'

const route = useRoute()

/**
 * The design system's own chrome — "Previous page", "Visible columns", the
 * palette hints — comes from this app's catalogue through `@erpx/ui`'s
 * injection seam, provided once here so a locale switch re-renders it
 * everywhere without a remount (see `i18n/uiStrings.ts`).
 */
provideUiStrings(uiStringsBundle())

/**
 * Login and MFA enrolment render without the shell: neither is navigable, and
 * showing a nav an operator cannot use yet (they are not through MFA) would be
 * a lie about what is reachable.
 */
const bare = computed(() => route.meta['layout'] === 'bare')

/**
 * The step-up dialog is mounted at the root, outside both layouts: a
 * `403 ERR_STEP_UP_REQUIRED` can come back from any request, so the thing that
 * answers it cannot belong to one screen (§6, §13).
 */
</script>

<template>
  <ETooltipProvider>
    <main v-if="bare" class="min-h-full bg-app">
      <RouterView />
    </main>
    <AppShell v-else>
      <RouterView />
    </AppShell>
    <StepUpDialog />
    <EToast />
  </ETooltipProvider>
</template>
